export default interface SHORTCUT
{
	MODULE_NAME                   : string;  // nvarchar
	DISPLAY_NAME                  : string;  // nvarchar
	RELATIVE_PATH                 : string;  // nvarchar
	IMAGE_NAME                    : string;  // nvarchar
	SHORTCUT_ACLTYPE              : string;  // nvarchar
}

